// extracted by mini-css-extract-plugin
export default {"landing":"Landing_landing__Zo764","scroll":"Landing_scroll__E6JHN"};